import React, { FC, memo } from "react";
import { useMedia } from "react-use";

import { MEDIA_SIZE_SM } from "@/core/media";
import { IJobRequest } from "@/data/job-requests";
import { DCCreateTaskActionType, IDCCreateTask } from "@/data/tasks/types";
import { Flex } from "@/eworkitComponents/index";
import { ContactSection } from "@/views/components/Contact";
import { DesignatedCandidate } from "@/views/components/JobRequests/Partials";
import { JobRequestManagedBySection } from "@/views/JobRequests/Detail/components/JobRequestManagedBySection";

import { DCCHeader } from "../DCCHeader";
import { DCCInformations } from "../DCCInformations";

export interface IDCCDetailsProps {
  task: IDCCreateTask;
  refresh?: () => void;
  onAction?: (actionType: DCCreateTaskActionType, comment: string, task: IDCCreateTask) => void;
}

export const DCCDetails: FC<IDCCDetailsProps> = memo(({ task, refresh, onAction }) => {
  const isSmallScreen = useMedia(MEDIA_SIZE_SM);
  const jobRequest: IJobRequest = task.entity;

  return (
    <Flex width={12} direction="column" innerMargin="md">
      <DCCHeader task={task} refresh={refresh} onAction={onAction} />

      {task.entity.designatedCandidate && (
        <DesignatedCandidate
          designatedCandidate={task.entity.designatedCandidate}
          shadow={isSmallScreen ? "none" : "default"}
          borderRadius={!isSmallScreen}
        />
      )}

      <DCCInformations jobRequest={task.entity} />

      {jobRequest.hiringManager && (
        <ContactSection
          contactPerson={jobRequest.hiringManager}
          originName={jobRequest.legalEntityName || jobRequest.origin.name}
        />
      )}

      {jobRequest.promoteClient && jobRequest.origin && <JobRequestManagedBySection jobRequest={jobRequest} />}
    </Flex>
  );
});
